import { Skeleton } from "@/components/ui/skeleton";

/** Generic page-shaped skeleton: nav bar, hero, and card grid. */
const PageSkeleton = () => (
  <div className="min-h-screen w-full bg-background" aria-busy="true" aria-label="Loading">
    <div className="container mx-auto flex h-16 items-center justify-between px-4">
      <Skeleton className="h-8 w-32 rounded-full" />
      <div className="hidden gap-3 md:flex">
        {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-8 w-20 rounded-full" />)}
      </div>
      <Skeleton className="h-10 w-10 rounded-full" />
    </div>
    <div className="container mx-auto space-y-5 px-4 py-16">
      <Skeleton className="mx-auto h-10 w-3/4 max-w-xl rounded-full" />
      <Skeleton className="mx-auto h-4 w-2/3 max-w-md rounded-full" />
      <div className="flex justify-center gap-3 pt-2">
        <Skeleton className="h-11 w-36 rounded-full" />
        <Skeleton className="h-11 w-36 rounded-full" />
      </div>
      <div className="grid gap-6 pt-10 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="space-y-3 rounded-2xl border p-4">
            <Skeleton className="aspect-video w-full" />
            <Skeleton className="h-5 w-2/3 rounded-full" />
            <Skeleton className="h-4 w-full rounded-full" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default PageSkeleton;
